var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.5 166.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 113.5,
    width: 122,
    height: 15,
    style: {
      fill: "#414141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,55.85c-5.61-18.54-27-32.35-52.55-32.35s-47,13.82-52.56,32.38A33.3,33.3,0,0,0,28.5,65.5v42h108v-42A33.17,33.17,0,0,0,135.05,55.85Z",
    style: {
      fill: "#414141"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 80,
    r: 13,
    style: {
      fill: "#fcff35"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 79,
    r: 13,
    style: {
      fill: "#fcff35"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 65.5,
    x2: 99,
    y2: 93,
    style: {
      fill: "none",
      stroke: "#414141",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 79,
    x2: 112,
    y2: 79,
    style: {
      fill: "none",
      stroke: "#414141",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 80,
    x2: 80,
    y2: 80,
    style: {
      fill: "none",
      stroke: "#414141",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.75,
    cy: 83.25,
    rx: 82.25,
    ry: 82.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ac97a3bcbf5121c379166f9dfaba466.svg";
export { ForwardRef as ReactComponent };